export function NavItem() {
  return (
    <div className="h-10 py-2 px-2 flex items-center w-full">
      <div className="h-5 w-5 sm:mr-3 rounded-full bg-skeleton-graphic animate-pulse" />
      <div className="sm:h-5 sm:w-8/12 rounded-full bg-skeleton-text animate-pulse invisible sm:visible" />
    </div>
  );
}
